/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'
import { Link } from 'react-router-dom'

/**
 *     Import
 *     - Components
 */
import ToolTip from '../../../common/ToolTip/ToolTip'

/**
 *     Import
 *     - Images
 */
import { ViewIcon } from '../../../../images/icons/View/View'
import { MtaIcon } from '../../../../images/icons/Mta/Mta'

/**
 * Each Quotes row from the ClientsTable component
 *
 * @export
 * @class ClientsRowQuotes
 * @extends {React.Component<any, any>}
 */
export default class ClientsRowQuotes extends React.Component<any, any> {

    /**
     * Will open the parent's PopUp
     *
     * @memberof ClientsRowQuotes
     */
    addMtaClick = (mtaId) => {
        if (!this.props.quote.cancelled && !this.props.quote.manual && !this.props.manageAgency) {
            this.props.openPopUp(mtaId)
        }
    }

    render() {
        return (
            <div>
                <div
                    className={`table__row ${(this.props.quote.mtas && this.props.quote.mtas.length !== 0) ?
                        'row_shadow' :
                        ''}`
                    }
                >
                    <div className="column" />
                    <div className="column no-margin">{this.props.quote.clientName}</div>
                    <div className="column">{this.props.quote.inceptionDate}</div>
                    <div className="column">{this.props.quote.policyNumber}</div>
                    <div className="column">£{this.props.quote.premium}</div>
                    <div className="column center">
                        <div
                            className=
                            {`${(this.props.manageAgency) ?
                                'disabled' :
                                ''}`}
                        >
                            <Link
                                to={`${(!this.props.manageAgency) ?
                                    '/clients/policies/view/' + this.props.quote.id :
                                    null}`}
                            >
                                <ViewIcon />
                            </Link>
                        </div>
                        <div
                            className=
                            {`${(this.props.quote.cancelled || this.props.quote.manual || this.props.manageAgency) ?
                                'disabled' :
                                ''}`}
                            onClick={() => this.addMtaClick(this.props.quote.id)}
                        >
                            <MtaIcon />
                        </div>
                    </div>
                </div>
                {(this.props.quote.mtas) ?
                    this.props.quote.mtas.map((item, i) => (
                        <div
                            className="policiesListRow__row--mtas"
                            key={i}
                        >
                            <div className="column--mtas" />
                            <div className="column--mtas">{item.title}</div>
                            <div className="column--mtas">Effective date: {item.effectiveDate}</div>
                            <div className="column--mtas">Expiry date: {item.expiryDate}</div>
                            <div className="column--mtas">
                                <div className="text">
                                    {item.statusMessage}
                                </div>
                                {
                                    item.statusMessage !== 'bound' &&
                                    <ToolTip position="left" verticalPosition="top">
                                        This is a Tooltip!
                                    </ToolTip>
                                }
                            </div>
                            <div className="column--mtas">
                                {
                                    item.statusMessage !== 'bound' &&
                                    <Link to={`/clients/policies/mta/${this.props.quote.id}/summary/${item.id}`}>
                                        <ViewIcon />
                                    </Link>
                                }
                            </div>
                        </div>
                    ))
                    :
                    null
                }
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Clients/components/ClientsRowPolicies.tsx